import { gql } from "apollo-angular";
import { CBF } from "./content-block"
import { LINK_FIELDS } from "./link";

export const PFH = gql`
  fragment PFH on ProgramFinderHybride {
    sys {
      id
    }
    title
    backgroundColor {
      color
    }
    cb:content {
      ... CBF
    }
    backgroundImage {
      url
      description
      sys {
        id
      }
    }
    itemListCollection (limit:10) {
      items {
        ...LINK_FIELDS 
        ... on ListItem{
          text
					icon
        }
      }
    }
    showPricing
    hideMobileImage
    form {
      ... on SifGenericForm {
        sys {
          id
        }
      }
    }
  }
 ${CBF}
 ${LINK_FIELDS}`;
